<template>
  <div class="paginated-field">
    <PaginatedListModal
            :value="readonly ? false: dialog"
            :data-source-url="apiUrl"
            :headers="headers"
            :selectable="multi"
            :selected.sync="items"
            :toolbar-title="label"
            @close="dialog = false"
            @select="selectMultiple($event)"
            @itemClick="selectRegistro($event.item)">
    </PaginatedListModal>
    <SelectField
        @input="$emit('input', $event)"
        @click.native="dialog = true"
        :items-source="itemsSource"
        :value="value"
        :multi="multi"
        :append-icon="appendIcon"
        :clearable="clearable"
        :readonly="readonly"
        :required="required"
        :icon="icon"
        :disabled="disabled"
        :extra-opt="extraOpt"
        :error-messages="errorMessages"
        :hint-text="hintText"
        :item-text="itemText"
        :item-value="itemValue"
        :label="label"
        :name="name"
    ></SelectField>
  </div>
</template>

<script>
  import PaginatedListModal from "../PaginatedListModal";
  import fieldMixin from "./mixins/fieldMixin";
  import SelectField from '@/components/generic-fields/SelectField';

export default {
  name: "PaginatedListModalField",
  components: { SelectField, PaginatedListModal },
  extends: SelectField,
  mixins: [fieldMixin],
  props: {
    headers: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      loading: false,
      error: false,
      items: [],
      lastRequest: null,
      chipsMaxLength: 64,
      valor: null,
      dialog : false,
    };
  },
  mounted() {
    if(this.value){
      this.getRegistro();
    }
  },
  methods: {
    selectRegistro (value) {
      if (!this.multi) {
        this.valor = value;
        this.items = [];
        this.items.push(value);
        this.dialog = false;
        this.$emit('input', value[this.itemValue]);
      }
    },
    selectMultiple(selected) {
      this.dialog = false;
      this.$emit('input', selected.map(v => v[this.itemValue]));
    },
    clear() {
      this.valor = null;
    },
    getItems() {

    },
    getRegistro() {
      this.loading = true;
      this.error = false;
      if (!this.multi) {
        this.$http
            .get(`${this.apiUrl}/${this.value}`).then(r => r.json())
            .then(entity => {
                  this.items.push(entity);
                  this.loading = false;
                },
                (error) => {
                  this.loading = false;
                  this.error = true;
                });
      } else {
        let filters = [`id:${this.value}`];
        let params = {filters};
        this.$http
            .get(`${process.env.VUE_APP_ROOT_API}${this.apiUrl}`, params).then(r => r.json())
            .then(entity => {
                  this.items.push(entity);
                  this.loading = false;
                },
                (error) => {
                  this.loading = false;
                  this.error = true;
                });
      }
    },

  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.valor = val;
      }
    },
  },
  computed: {
    apiUrl() {
      return this.itemsSource;
    }
  },

}
</script>

<style scoped>

</style>
